import styled from "styled-components";
import { theme } from "@themes";

export const UploadSection = styled.div`
  display: flex;
  justify-items: flex-start;
  align-items: center;
  padding: 0.4em;
  grid-template-columns: 100%;
  grid-gap: 1em;
  border: 1px solid ${({ theme }) => theme.neutral.gray[900]};
  border-radius: 4px;
  outline: 0;
  box-sizing: border-box;
  font-size: 14px;
  color: ${({ theme }) => theme.text.secondary};

  Button {
    font-family: ${({ theme }) => theme.font.primary};
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 22px;
    color: ${({ theme }) => theme.text.primary};
    background-color: ${({ theme }) => theme.neutral.gray[700]};
    margin-top: 0px !important;
    padding: 4px 5px;
  }

  button {
    margin-top: 0px !important;
  }
`;
